import { createApp, watch } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import i18n from './i18n'; // Importar la instancia i18n configurada
import { axios } from './axios' 
import { useUserStore } from '@/stores/user'

loadFonts();

const app = createApp(App);
const pinia = createPinia()

app.use(pinia)
app.use(router);
app.use(vuetify);
app.use(i18n); // Usar la instancia i18n

// 1) Header inicial según el locale que tengas guardado
axios.defaults.headers.common['Accept-Language'] = i18n.global.locale.value

// 2) Watch del locale para actualizar el header (y opcionalmente la cookie)
watch(
  () => i18n.global.locale.value,
  newLocale => {
    axios.defaults.headers.common['Accept-Language'] = newLocale
    document.cookie = `django_language=${newLocale}; Path=/`
  }
)

// **Aquí** Pinia ya está instalado, así que usar useUserStore() funciona
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  const isAuth    = userStore.isLoggedIn

  // Si necesito auth y no la tengo
  if (to.meta.requiresAuth && !isAuth) {
    return next({ path: '/login' })
  }

  // Si necesito roles y no los tengo
  if (to.meta.requiresRoles) {
    // si nunca he cargado detalles (por recarga), los pido
    if (isAuth && !userStore.userDetails) {
      try {
        await userStore.fetchUserDetails()
      } catch {
        userStore.logout()
        return next({ path: '/login' })
      }
    }

    const userRoles = userStore.userDetails?.roles || []
    const ok = to.meta.requiresRoles.some(r => userRoles.includes(r))
    if (!ok) {
      return next({ path: '/no-autorizado' })
    }
  }

  return next()
})

app.mount('#app');